import Lightbox from './_lightbox.js';

if (!Element.prototype.matches)
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

window.onload = function() {
	var container = document.querySelector('.thumbnails');
	var images = document.querySelectorAll('img.portfolio-image');

	var lightbox = new Lightbox(Array.from(images).map(i => i.src));

	container.addEventListener('click', event => {
		if(event.target.matches('img.portfolio-image')) {
			lightbox.go(parseInt(event.target.dataset.index));
			lightbox.show();
		}
	});
};
